/**
 * What a screen needs to know about the live chat connection, without knowing
 * who provides it.
 *
 * It lives here rather than next to the screen that consumes it, and the
 * reason is mechanical. A route that lazy-loads a screen and statically
 * imports a token from that same library stops lazy-loading anything: webpack
 * resolves the dynamic import to a synchronous reference, and the screen
 * arrives with the route that was meant to defer it. That is what the
 * admin route did, and the compiled output showed it plainly, a
 * `Promise.resolve().then(...)` where every neighbouring route had a
 * `Promise.all([t.e(...)])`.
 *
 * A token has no reason to travel with a screen. Here it travels with the
 * chat domain, which both the API and the mobile app already depend on, and
 * the screen stays where it belongs, behind its own chunk.
 *
 * Declared as a class rather than an InjectionToken because Angular needs a
 * value to `provide` against and the consumer injects it by type.
 */
export class ChatHandler {
  isConnected!: boolean;
}
